<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Annotation Works
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="/annotation-works/add" v-if="$auth.user().AuthScope.includes('annotation:manage')">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :loading="annotationWorkListLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.name }}</td>
                <td>
                  <v-chip
                  class="white--text"
                  small
                  color="accent">
                    {{ datasets[props.item.dataset] }}
                  </v-chip>
                </td>
                <td>{{ props.item.topicModel || '-' }}</td>
                <td>{{ `${props.item.annotationCount}/${props.item.targetCount}` }}</td>
                <td>{{ annotationTypeCollection[props.item.annotationType] }}</td>
                <td>{{ agreementLevelCollection[props.item.agreementLevel] }}</td>
                <td>{{ annotationStatusCollection[props.item.status] }}</td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td class="justify-end layout pl-0 pr-2 py-2">
                  <v-tooltip bottom color="grey">
                    <v-icon
                      class="mr-2"
                      color="grey"
                      slot="activator"
                      @click="exportItem(props.item)"
                    >
                      cloud_download
                    </v-icon>
                    <span>Export Annotation</span>
                  </v-tooltip>
                  <v-tooltip bottom color="success">
                    <v-icon
                      class="mr-2"
                      color="success"
                      slot="activator"
                      @click="$router.push(`/annotation-works/${props.item.id}/statistics`)"
                    >
                      insert_chart
                    </v-icon>
                    <span>Show Statistics</span>
                  </v-tooltip>
                  <v-tooltip bottom color="accent" v-if="$auth.user().AuthScope.includes('annotation:manage')">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/annotation-works/${props.item.id}/edit`)"
                    >
                      edit
                    </v-icon>
                    <span>Edit Item</span>
                  </v-tooltip>
                  <v-tooltip bottom color="error" v-if="$auth.user().AuthScope.includes('annotation:manage')">
                    <v-icon
                      color="error"
                      slot="activator"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>Delete Item</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
          v-model="dialog"
          max-width="500"
        >
      <v-card>
        <v-card-title class="headline">Delete annotation work</v-card-title>
        <v-card-text>
          Are you sure to delete this annotation work?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'Dataset', sortable: false, value: 'dataset'},
        {text: 'Topic Model', sortable: false, value: 'topicModel'},
        {text: 'Progress', sortable: false, value: 'progress'},
        {text: 'Annotation Type', sortable: false, value: 'annotationType'},
        {text: 'Agreement Level', sortable: false, value: 'agreementLevel'},
        {text: 'Status', sortable: false, value: 'status'},
        {text: 'Created Date', sortable: true, value: 'createdDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      itemToDelete: {},
      deleteLoading: false,
      annotationWorkListLoading: false,
      pagination: {
        sortBy: 'id'
      },
      datasets: []
    }
  },
  created () {
    this.annotationWorkListLoading = true
    this.axios.get(`/datasets`)
      .then(response => {
        this.datasets = response.data.reduce((map, obj) => {
          map[obj.id] = obj.name
          return map
        }, {})
        this.fetchAnnotationWorks()
      })
      .catch(error => {
        this.handleAxiosError(error)
        this.annotationWorkListLoading = true
      })
  },
  computed: {
    ...mapState({
      annotationTypeCollection: state => state.configurations.annotationTypesDictionary,
      agreementLevelCollection: state => state.configurations.agreementLevelsDictionary,
      annotationStatusCollection: state => state.configurations.annotationStatusDictionary
    })
  },
  methods: {
    fetchAnnotationWorks () {
      this.axios.get('/annotation-works')
        .then(response => {
          response.data.forEach(annotationWork => {
            this.items.push({
              id: annotationWork.id,
              name: annotationWork.name,
              createdDate: new Date(annotationWork.created_date),
              targetCount: annotationWork.target_count,
              dataset: annotationWork.dataset,
              topicModel: annotationWork.topic_model,
              annotationCount: annotationWork.annotation_count,
              annotationType: annotationWork.annotation_type,
              agreementLevel: annotationWork.agreement_level,
              status: annotationWork.status,
              editLink: `/annotation-works/${annotationWork.id}/edit`
            })
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.annotationWorkListLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/annotation-works/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    },
    exportItem (itemToExport) {
      this.annotationWorkListLoading = true
      if (itemToExport.annotationCount > 10000) {
        this.setSnack({
          message: 'This annotation work has more than 10000 instances. Preparing the file may take a while. Wait for downloading!',
          type: 'info',
          timeout: 4000
        })
      }

      this.axios({
        url: `/annotation-works/${itemToExport.id}/export/?`,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'annotation_work.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          this.handleAxiosError(error)
        }).finally(() => {
          this.annotationWorkListLoading = false
        })
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack'
    })
  }
}
</script>

<style>

</style>
